import request from "@/utils/request";

//查看问题
export function search_feedback(data) {
    return request({
        url: "/search_feedback",
        method: "post",
        data: data,
    });
}

//回复问题
export function answer_question(data) {
    return request({
        url: "/answer_question",
        method: "post",
        data: data,
    });
}